import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import { ENV } from '@app/constants/env';
import type { ResponseEntityDef, ResponseEntityErrorDef } from '@app/types/api.types';
import { getToken } from '@app/helpers/authProvider';

// import { getToken } from "@app/AuthProvider/keycloakAuthProvider";
export const apiFactory = <Error = ResponseEntityErrorDef>({
  reducerPath,
  baseUrl,
}: {
  reducerPath: string; // action type namespace
  baseUrl: string;
}) => createApi({
  reducerPath,
  baseQuery: retry(
    async (args, api, extraOptions) => {
      const result = await fetchBaseQuery({
        baseUrl,
        async prepareHeaders (headers) {
          if (!headers.has('Content-Type')) {
            headers.set('Content-Type', 'application/json; charset=utf-8');
          }
          const token = await getToken();
          if (token) headers.set("authorization", `Bearer ${token}`);

         console.log(token);

          return headers;
        },
      })(args, api, extraOptions);

      const meta = result.meta && { ...result.meta, timestamp: Date.now() };

      if (result.error) {
        return {
          error: result.error.data as Error,
          meta,
        };
      }

      const _result = result.data as { page?: unknown; pageInfo?: unknown };

      return {
        data: {
          page: _result?.page ?? _result,
          pageInfo: _result?.pageInfo ?? undefined,
          status: result.meta?.response?.status ?? 200,
        } as ResponseEntityDef<unknown>,
        meta,
      };
    },
    { maxRetries: 0 },
  ),
  endpoints: () => ({}),
  keepUnusedDataFor: 10, // seconds, unmount<->mount
});

export const baseApi = apiFactory({
  reducerPath: 'api',
  baseUrl: ENV.API_URL,
}).enhanceEndpoints({
  addTagTypes: ['ChargeLine'],
});
